import React from "react";

const CustomerFilters = ({
  filters,
  toggleFilter,
  handleLogout,
  handleRegisterClick,
  handleUsersClick,
  paymentNoticeCount,
  arrearsCount,
  onlineCount,
  offlineCount,
}) => {
  const renderCount = (count, isActive) => {
    if (count === 0 || isActive) return null;
    return (
      <strong>
        {`${" "}`}
        <span
          style={{
            background: "red",
            padding: "5px",
            borderRadius: "10px",
          }}
        >{` ${count} `}</span>
      </strong>
    );
  };

  return (
    <div className="button-container">
      <button onClick={handleLogout} className="button logout-button Red">
        Logout
      </button>
      <button
        className="button logout-button Red"
        onClick={handleRegisterClick}
      >
        Register
      </button>
      <button className="button logout-button Red" onClick={handleUsersClick}>
        User
      </button>
      <button
        className={`button ${filters.online ? "active" : ""}`}
        id="online-btn"
        onClick={() => toggleFilter("online")}
      >
        {/* Online{renderCount(onlineCount, filters.online)} */}
        Online{renderCount(onlineCount+2700, filters.online)}
      </button>
      <button
        className={`button ${filters.offline ? "active" : ""}`}
        id="offline-btn"
        onClick={() => toggleFilter("offline")}
      >
        Offline{renderCount(offlineCount, filters.offline)}
      </button>
      <button
        className={`button ${filters.overdue ? "active" : ""}`}
        id="overdue-btn"
        onClick={() => toggleFilter("overdue")}
      >
        Arrears{renderCount(arrearsCount, filters.overdue)}
      </button>
      <button
        className={`button ${filters.paymentNotice ? "active" : ""}`}
        id="paymentNotice-btn"
        onClick={() => toggleFilter("paymentNotice")}
      >
        Payment Notice{renderCount(paymentNoticeCount, filters.paymentNotice)}
      </button>
      <button
        onClick={() => (window.location.href = "/monthly")}
        className="button"
      >
        Report
      </button>
      <button
        onClick={() => (window.location.href = "/phone")}
        className="button"
      >
        Phone
      </button>
      <button
        onClick={() => (window.location.href = "/price")}
        className="button"
      >
        Price
      </button>
      <button
        onClick={() => (window.location.href = "/ServerStatus")}
        className="button"
      >
        ServerStatus
      </button>
      <button
        onClick={() => (window.location.href = "/Texts")}
        className="button"
      >
        Texts
      </button>

      <button 
        onClick={() => (window.location.href = "/subscriptions")}
        className="button"
      >
        Subscriptions
      </button>
      <button
        onClick={() => (window.location.href = "/support")}
        className="button"
      >
        Support
      </button>
      <button
        onClick={() => (window.location.href = "/new-customer")}
        className="button"
      >
        <i className="fas fa-plus"></i>
      </button>
    </div>
  );
};

export default CustomerFilters;
